import { IconEdit, IconTrash, IconExternalLink } from '@tabler/icons-react';
import { type TOppositionBase } from '../../types/oppositionBase';

interface Params {
  onEdit: (base: TOppositionBase) => void
  onRemove: (base: TOppositionBase) => void
}

export const getColumns = ({ onEdit, onRemove }: Params) => [
  {
    title: 'Nombre',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Descripción',
    dataIndex: 'description',
    key: 'description',
    ellipsis: true
  },
  {
    title: 'Archivo',
    dataIndex: 'fileUrl',
    key: 'fileUrl',
    render: (fileUrl: string) => (
      <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-blue-600 dark:text-blue-400">
        <IconExternalLink size={15} />
        Ver PDF
      </a>
    )
  },
  {
    title: '',
    dataIndex: '',
    key: 'edit',
    width: 50,
    render: (_: unknown, base: TOppositionBase) => (
      <button className='table-action' onClick={() => { onEdit(base); }}>
        <IconEdit size={15} color="white" />
      </button>
    )
  },
  {
    title: '',
    dataIndex: '',
    key: 'remove',
    width: 50,
    render: (_: unknown, base: TOppositionBase) => (
      <button className='table-action' onClick={() => { onRemove(base); }}>
        <IconTrash size={15} color="white" />
      </button>
    )
  }
];
